
















import { Component, Vue, Watch } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
@Component
export default class Index extends Vue {
  async goDetail() {
    const tid = this.$route.query.tid
    await env.init()
    if (tid) {
      env.commonJump('ivydadreadtool://weex/new-order-details?tid=' + tid)
    } else {
      env.commonJump('ivydadreadtool://my/order?index=1')
    }
  }
  async goHome() {
    await env.init()
    env.commonJump('ivydadreadtool://home/family')
  }
}
